export const MBDimensions = {
  get width(): number {
    return window.innerWidth;
  },
  get height(): number {
    return window.innerHeight;
  },
};
